<template>
  <ts-modal
      ref="modal"
      id="participantInviteModal"
      modal-class="modal-form participant-invite-modal"
      modal-title="Invite participant to event"
  >
    <template #modal-content>
      <p class="mb-1">Select a message which will be sent to participant</p>
      <div class="ms-4 mb-2">
        <div class="form-check">
          <input
              id="messageType1"
              v-model="invitationMessageType"
              type="radio"
              class="form-check-input"
              value="1"
          >
          <label
              class="form-check-label mb-0"
              for="messageType1"
          >
            Send invitation for registration
          </label>
        </div>
        <div class="form-check">
          <input
              id="messageType2"
              v-model="invitationMessageType"
              type="radio"
              class="form-check-input"
              value="2"
          >
          <label
              class="form-check-label mb-0"
              for="messageType2"
          >
            Send reimbursement and post-event survey
          </label>
          <small class="form-text text-muted">
            Usually use this option if event has already been held
          </small>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button
          type="button"
          class="btn btn-sm btn-secondary"
          data-bs-dismiss="modal"
      >
        Close
      </button>
      <button
          type="button"
          class="btn btn-sm btn-primary"
          @click="inviteParticipant"
      >
        Invite
      </button>
    </template>
  </ts-modal>
</template>

<script setup lang="ts">

const emit = defineEmits<{
  (e: 'success', inviteUrl: string | null, messageType: number): void
}>()

import {ref, useTemplateRef} from 'vue'
import TsModal from './ts-modal.vue'
import {isPresent} from '../js-utils'

const modal = useTemplateRef<InstanceType<typeof TsModal>>('modal')

const inviteUrl = ref<string | null>(null)
const invitationMessageType = ref<number>(1)

const showModal = (anInviteUrl: string, messageType: number | null): void => {
  if (isPresent(messageType) && messageType === 2) {
    invitationMessageType.value = 2
  } else {
    invitationMessageType.value = 1
  }
  inviteUrl.value = anInviteUrl
  modal.value?.show()
}

const hideModal = (): void => {
  modal.value?.hide()
}

const inviteParticipant = (): void => {
  emit('success', inviteUrl.value, invitationMessageType.value)
}

defineExpose({
  showModal,
  hideModal
})
</script>
